import type { MessageKey } from './en'

export const ar: Record<MessageKey, string> = {
  'app.name': 'COREX',
  'app.tagline': 'نظام إدارة الشحن',
  'common.search': 'بحث',
  'common.searchPlaceholder': 'ابحث…',
  'common.filters': 'الفلاتر',
  'common.clear': 'مسح',
  'common.apply': 'تطبيق',
  'common.reset': 'إعادة ضبط',
  'common.save': 'حفظ',
  'common.saving': 'جار الحفظ…',
  'common.cancel': 'إلغاء',
  'common.close': 'إغلاق',
  'common.confirm': 'تأكيد',
  'common.delete': 'حذف',
  'common.edit': 'تعديل',
  'common.create': 'إنشاء',
  'common.add': 'إضافة',
  'common.remove': 'إزالة',
  'common.view': 'عرض',
  'common.details': 'التفاصيل',
  'common.actions': 'إجراءات',
  'common.export': 'تصدير',
  'common.exportExcel': 'تصدير Excel',
  'common.print': 'طباعة',
  'common.refresh': 'تحديث',
  'common.retry': 'حاول مرة أخرى',
  'common.loading': 'جار التحميل…',
  'common.yes': 'نعم',
  'common.no': 'لا',
  'common.all': 'الكل',
  'common.none': 'لا شيء',
  'common.from': 'من',
  'common.to': 'إلى',
  'common.date': 'التاريخ',
  'common.status': 'الحالة',
  'common.notes': 'ملاحظات',
  'common.total': 'الإجمالي',
  'common.selected': '{count} محدد',
  'common.rows': '{count} صف',
  'common.page': 'صفحة {page}',
  'common.of': 'من {total}',
  'common.perPage': 'لكل صفحة',
  'common.previous': 'السابق',
  'common.next': 'التالي',
  'common.copy': 'نسخ',
  'common.copied': 'تم النسخ',
  'common.required': 'مطلوب',
  'common.optional': 'اختياري',
  'common.post': 'ترحيل',
  'common.unpost': 'إلغاء الترحيل',
  'common.posted': 'مرحل',
  'common.draft': 'مسودة',
  'common.back': 'رجوع',
  'common.new': 'جديد',
  'common.open': 'فتح',
  'common.today': 'اليوم',
  'common.last7': 'آخر 7 أيام',
  'common.last30': 'آخر 30 يوم',
  'common.last90': 'آخر 3 شهور',
  'common.thisMonth': 'هذا الشهر',
  'empty.title': 'لا توجد بيانات بعد',
  'empty.filtered': 'لا توجد نتائج مطابقة',
  'empty.filteredHint': 'جرب توسيع الفترة أو مسح الفلاتر.',
  'error.title': 'حدث خطأ',
  'error.forbidden': 'ليس لديك صلاحية',
  'error.forbiddenHint': 'اطلب من مدير النظام منحك صلاحية «{permission}».',
  'error.offline': 'أنت غير متصل',
  'error.offlineHint': 'لا يمكن إرسال التعديلات حتى يعود الاتصال.',
  'error.network': 'تعذر الوصول للخادم',
  'error.notFound': 'الصفحة غير موجودة',
  'error.requestId': 'المرجع: {id}',
  'auth.signIn': 'تسجيل الدخول',
  'auth.signingIn': 'جار تسجيل الدخول…',
  'auth.signOut': 'تسجيل الخروج',
  'auth.username': 'اسم المستخدم',
  'auth.password': 'كلمة المرور',
  'auth.welcome': 'مرحبا بعودتك',
  'auth.subtitle': 'سجل الدخول بحساب Dispatch الخاص بك.',
  'auth.sessionEnded': 'انتهت الجلسة. سجل الدخول مرة أخرى.',
  'auth.evicted': 'تم تسجيل خروجك لأن هذا الحساب سجل الدخول من مكان آخر.',
  'auth.noPermissions': 'لم يتم تعيين صلاحيات لحسابك بعد',
  'auth.noPermissionsHint': 'يجب على مدير النظام تعيين دور للمستخدم «{user}» (دور Dispatch رقم {role}).',
  'auth.changePassword': 'تغيير كلمة المرور',
  'auth.currentPassword': 'كلمة المرور الحالية',
  'auth.newPassword': 'كلمة المرور الجديدة',
  'auth.passwordChanged': 'تم تغيير كلمة المرور',
  'shell.toggleSidebar': 'إظهار/إخفاء القائمة',
  'shell.searchNav': 'ابحث في الصفحات…',
  'shell.commandHint': 'انتقل إلى صفحة أو ابحث برقم شحنة أو رقم هاتف',
  'shell.noNavResults': 'لا توجد صفحات مطابقة',
  'shell.theme': 'المظهر',
  'shell.themeLight': 'فاتح',
  'shell.themeDark': 'داكن',
  'shell.themeSystem': 'حسب النظام',
  'shell.language': 'اللغة',
  'shell.density': 'كثافة العرض',
  'shell.densityComfortable': 'مريح',
  'shell.densityCompact': 'مضغوط',
  'shell.errorSoundOn': 'تشغيل صوت التنبيه',
  'shell.errorSoundOff': 'إيقاف صوت التنبيه',
  'shell.branch': 'الفرع',
  'shell.switchBranch': 'تغيير الفرع',
  'shell.home': 'الرئيسية',
  'shell.offlineBanner': 'غير متصل — يتم عرض البيانات المحفوظة إن وجدت.',
  'shell.updateAvailable': 'يتوفر إصدار جديد',
  'shell.reload': 'تحديث',
  'shell.installApp': 'تثبيت التطبيق',
  'gap.title': 'بانتظار دعم Backend',
  'gap.body': 'هذه الشاشة ضمن خطة النظام، لكن واجهة Dispatch API الحالية لا تحتوي على Endpoint لها. سيتم تفعيلها فور توفر Backend الموضح أدناه — ولن تعرض أي بيانات وهمية.',
  'gap.required': 'Backend / API المطلوب',
  'gap.related': 'شاشات مرتبطة تعمل حاليا',
  'gap.reference': 'مرجع الفجوة',
  'table.columns': 'الأعمدة',
  'awb.scanPlaceholder': 'امسح أو الصق أرقام الشحنات (رقم في كل سطر أو مفصولة بفاصلة/مسافة)',
  'awb.count': '{count} شحنة',
  'awb.invalid': '{count} غير صالح',
  'awb.duplicates': 'تم حذف {count} مكرر',
}
